"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pic = void 0;
exports.pic = {
    path: "M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 15.8333H4.16667V4.16667H15.8333V15.8333ZM9.34167 13.1917L11.6333 10.2417L14.5833 14.1667H5.41667L7.70833 11.225L9.34167 13.1917Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
